/*
  Aercover: cart shipping bar + upsells (CONCEPT theme)
  - Handles the "Add case" (variant swap) and "Add set" buttons.
  - Re-renders the cart items, footer, cart icon and its own sections after a change.
  - Listens to Dawn's cart-update event so the bar also refreshes after +/- or remove.
*/
(function () {
  if (window.__aerCartUpsell) return;
  window.__aerCartUpsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ownSections() {
    return Array.prototype.map.call(document.querySelectorAll('[data-aer-section]'), function (el) {
      return { id: el.dataset.sectionId, selector: '#aer-cart-upsell-' + el.dataset.sectionId };
    });
  }

  function cartSections() {
    var list = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items) list.push({ id: items.dataset.id, selector: '#main-cart-items .js-contents' });
    if (footer) list.push({ id: footer.dataset.id, selector: '#main-cart-footer .js-contents' });
    if (document.getElementById('cart-icon-bubble')) list.push({ id: 'cart-icon-bubble', selector: '#cart-icon-bubble .shopify-section', fallback: '#cart-icon-bubble', source: '.shopify-section' });
    return list;
  }

  function render(sections, list) {
    list.forEach(function (s) {
      var html = sections && sections[s.id];
      var target = document.querySelector(s.selector) || (s.fallback && document.querySelector(s.fallback));
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(s.source || s.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function refreshOwn() {
    var list = ownSections();
    if (!list.length) return;
    var ids = list.map(function (s) { return s.id; }).join(',');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids))
      .then(function (r) { return r.json(); })
      .then(function (sections) { render(sections, list); })
      .catch(function () {});
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var upgrade = e.target.closest('[data-aer-upgrade]');
    var addSet = e.target.closest('[data-aer-add-set]');
    if (!upgrade && !addSet) return;
    e.preventDefault();

    var card = e.target.closest('.aer-up');
    if (card) card.setAttribute('aria-busy', 'true');

    var all = cartSections().concat(ownSections());
    var ids = all.map(function (s) { return s.id; }).join(',');
    var request;

    if (upgrade) {
      var updates = {};
      updates[upgrade.dataset.removeVariant] = 0;
      updates[upgrade.dataset.addVariant] = parseInt(upgrade.dataset.qty, 10) || 1;
      request = post('cart/update.js', { updates: updates, sections: ids, sections_url: window.location.pathname });
    } else {
      var select = card && card.querySelector('[data-aer-set-select]');
      if (!select || !select.value) { if (card) card.removeAttribute('aria-busy'); return; }
      request = post('cart/add.js', {
        items: [{ id: parseInt(select.value, 10), quantity: 1 }],
        sections: ids,
        sections_url: window.location.pathname
      });
    }

    request.then(function (res) {
      if (res && res.sections) {
        render(res.sections, all);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aer-cart-upsell', cartData: res });
        }
      } else {
        window.location.reload();
      }
    }).catch(function () { window.location.reload(); });
  });

  // Dawn publishes cart-update after quantity changes and removals on the cart page.
  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'aer-cart-upsell') return;
        refreshOwn();
      });
      return true;
    }
    return false;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
